import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { themed } from '@/shared/ui/core';

export const IconWrapper = styled(Link)``;

export const TableWrapper = styled.div.attrs({
  className: 'TableWrapper',
})`
  width: 100%;
  padding: 0;

  * {
    flex-shrink: 0;
  }

  > div {
    padding: 0;
  }

  > .Title {
    margin-bottom: 0.75rem;
  }
`;

export const TableStyled = styled.table`
  width: 100%;
  border-collapse: collapse;

  svg {
    fill: ${themed('primary.accent')};
    width: 1.75rem;
    height: 1.75rem;
    padding: 0.25rem;
  }

  span + span {
    width: 100%;
  }

  caption {
    font-size: 1.5625rem;
    font-weight: 700;
    height: 2.125rem;
    line-height: 1.25;
    text-align: left;
    color: ${themed('primary.text')};
    margin-bottom: 0.75rem;
  }
`;

export const TableHeader = styled.thead`
  text-align: left;
`;

export const TableHead = styled.th`
  height: 100%;

  .Text {
    color: ${themed('primary.accent')};
    font-size: 1.25rem;
  }

  &:first-of-type {
    width: 39%;
  }
`;

export const TableBody = styled.tbody``;

export const TableData = styled.td.attrs({
  className: 'TableData',
})`
  height: ${({ variableHeight }) => (variableHeight ? 'unset' : '3.625rem')};
  padding: 0;

  span {
    display: flex;
    width: 100%;
  }

  a {
    margin-left: auto;
    svg {
      margin-left: auto;
    }
  }
`;

export const TableRow = styled.tr.attrs({
  className: 'TableRow',
})`
  width: 100%;

  &:last-of-type > td:first-of-type > span {
    position: relative;
    top: 0.25rem;
  }

  &:not(:last-of-type) {
    border-bottom: ${({ border }) => (border ? '2px solid #E9ECED;' : 'none')};
  }

  & td:first-of-type {
    padding-right: 0.75rem;
    width: 39%;
  }
`;

export const ExpiredNotice = styled.div`
  color: ${themed('status.error.main')};
  display: block !important;
  font-size: 0.75rem;
  font-weight: 600;
  position: relative;
  bottom: 0.75rem;

  a:link,
  a:visited {
    color: inherit;
    margin: 0;
    text-decoration: underline;
  }
`;
